import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/tenant';
import { Shield, LogIn, Loader2, AlertCircle } from 'lucide-react';
export function GlobalAdminLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    user,
    loading,
    signIn
  } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Where to redirect after login
  const from = (location.state as any)?.from || '/admin/enrollment';
  // If already logged in, redirect
  useEffect(() => {
    if (!loading && user) {
      navigate(from, {
        replace: true
      });
    }
  }, [user, loading, navigate, from]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    console.log('[AdminLogin] Attempting sign in...', {
      email: email.trim().toLowerCase(),
      passwordLength: password.length,
      redirectTo: from
    });
    try {
      await signIn(email.trim().toLowerCase(), password);
      console.log('[AdminLogin] Sign in SUCCESS — redirecting to:', from);
      navigate(from, {
        replace: true
      });
    } catch (err: any) {
      console.error('[AdminLogin] Sign in FAILED:', {
        message: err.message,
        status: err.status,
        name: err.name,
        fullError: err
      });
      // Provide specific guidance for known errors
      if (err.message?.includes('Invalid API key')) {
        setError('Error de configuración: API key inválida. Contacta al administrador del sistema.');
      } else if (err.message?.includes('Invalid login credentials')) {
        setError('Correo o contraseña incorrectos.');
      } else {
        setError(err.message || 'Error al iniciar sesión.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  if (loading) {
    return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center" data-id="element-2651">
        <Loader2 className="w-8 h-8 text-[#006847] animate-spin" data-id="element-2652" />
      </div>;
  }
  return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans flex items-center justify-center p-6" data-id="element-2653">
      <div className="max-w-sm w-full space-y-8" data-id="element-2654">
        <div className="text-center space-y-3" data-id="element-2655">
          <div className="w-16 h-16 bg-[#141414] border border-white/10 rounded-2xl flex items-center justify-center mx-auto" data-id="element-2656">
            <Shield className="w-8 h-8 text-[#006847]" data-id="element-2657" />
          </div>
          <h1 className="text-2xl font-black tracking-tight" data-id="element-2658">NOIZA Admin</h1>
          <p className="text-white/40 text-sm" data-id="element-2659">
            Inicia sesión para acceder al panel de administración
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2660">
          <div data-id="element-2661">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-2662">
              Correo electrónico
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@noiza.com" className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" required autoFocus data-id="element-2663" />
          </div>

          <div data-id="element-2664">
            <label className="block text-xs font-bold text-white/40 uppercase tracking-widest mb-2" data-id="element-2665">
              Contraseña
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-4 text-base text-white placeholder:text-white/15 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" required data-id="element-2666" />
          </div>

          {error && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center gap-2 text-red-400 text-sm" data-id="element-2667">
              <AlertCircle className="w-4 h-4 shrink-0" data-id="element-2668" />
              {error}
            </div>}

          <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-bold text-base rounded-xl transition-all flex items-center justify-center gap-2 active:scale-95" data-id="element-2669">
            {isSubmitting ? <>
                <Loader2 className="w-5 h-5 animate-spin" data-id="element-2670" />
                Iniciando sesión...
              </> : <>
                <LogIn className="w-5 h-5" data-id="element-2671" />
                Iniciar sesión
              </>}
          </button>
        </form>
      </div>
    </div>;
}